import Content from "components/Content";
import Label from "components/Label";
import Media from "components/Media";
import React, { FC } from "react";

import Table from "./components/Table";
import styles from "./styles.module.scss";

import {
  mobileVendorColumns,
  vendorColumns,
  wholeHomeMaintenance
} from "./constants";

const WeAreLookingFor: FC = () => (
  <Content
    containerClassName={styles.wrapper}
    contentClassName={styles.container}
  >
    <Label className={styles.title} variant="h2-centered" color="primary">
      We&apos;re looking for vendors that offer...
    </Label>
    <Media at={["desktop", "tablet"]}>
      <Table columns={vendorColumns} />
    </Media>
    <Media at={["mobile"]}>
      <Table columns={mobileVendorColumns} />
      <div className={styles.wholeHomeMaintenance}>
        <wholeHomeMaintenance.Icon className={styles.icon} />
        <Label color="secondary" variant="centered-body">
          {wholeHomeMaintenance.name}
        </Label>
      </div>
    </Media>
  </Content>
);

export default WeAreLookingFor;
